import React from "react";
// @material-ui/core components
import withStyles from "@material-ui/core/styles/withStyles";
import InputLabel from "@material-ui/core/InputLabel";

import Select from "@material-ui/core/Select";
import Input from "@material-ui/core/Input";
import MenuItem from "@material-ui/core/MenuItem";
import FormControl from "@material-ui/core/FormControl";
import ListItemText from "@material-ui/core/ListItemText";
import Checkbox from "@material-ui/core/Checkbox";
import ErrorOutlineIcon from "@material-ui/icons/ErrorOutline";

// core components
import GridItem from "components/Grid/GridItem.jsx";
import GridContainer from "components/Grid/GridContainer.jsx";
import CustomInput from "components/CustomInput/CustomInput.jsx";
import Button from "components/CustomButtons/Button.jsx";
import Card from "components/Card/Card.jsx";
import CardHeader from "components/Card/CardHeader.jsx";
import CardBody from "components/Card/CardBody.jsx";
import CardFooter from "components/Card/CardFooter.jsx";
import Snackbar from "components/Snackbar/Snackbar.jsx";

import FormControlLabel from "@material-ui/core/FormControlLabel";

import httpr from "lib/httpRequest";
import { BASE_URL, AUTH_OPTIONS } from "lib/config";
import memberValidation from "../../lib/validation/memberValidation";

const styles = (theme) => ({
  //const styles = {
  textField: {
    marginLeft: theme.spacing.unit,
    marginRight: theme.spacing.unit,
  },
  addMemberControler: {
    marginLeft: theme.spacing.unit + 10,
    marginRight: theme.spacing.unit + 10,
  },
  checkBox: {
    marginLeft: 0,
    marginRight: 0,
    margin: 0,
    padding: 0,
    fontSize: "14px",
  },
  formControl: {
    width: "100%",
  },
  cardCategoryWhite: {
    color: "rgba(255,255,255,.62)",
    margin: "0",
    fontSize: "14px",
    marginTop: "0",
    marginBottom: "0",
  },
  cardTitleWhite: {
    color: "#FFFFFF",
    marginTop: "0px",
    minHeight: "auto",
    fontWeight: "300",
    fontFamily: "'Roboto', 'Helvetica', 'Arial', sans-serif",
    marginBottom: "3px",
    textDecoration: "none",
  },
});

const ITEM_HEIGHT = 48;
const ITEM_PADDING_TOP = 8;
const MenuProps = {
  PaperProps: {
    style: {
      maxHeight: ITEM_HEIGHT * 4.5 + ITEM_PADDING_TOP,
      width: 250,
    },
  },
};

class EditMember extends React.Component {
  _isMounted = false;
  constructor(props) {
    super(props);

    this.state = {
      locations: this.props.locations,
      selectedLocIds: [],
      reports: this.props.reports,
      selectedReports: [],
      allReportsSelected: true,
      admin: false,
      service: false,
      email: "",
      confirmEmail: "",
      password: "",
      confirmPassword: "",
      firstName: "",
      lastName: "",
      emailErr: false,
      pwErr: false,
      fNameErr: false,
      lNameErr: false,
      locErr: false,
      serviceLocErr: false,
      mem: null,
      snackbarOpen: false,
      snackbarMsg: "",
    };
  }

  componentDidMount() {
    this._isMounted = true;
    this.getMemberInfo();
  }
  componentWillUnmount() {
    this._isMounted = false;
  }

  getMemberInfo = () => {
    const token = localStorage.getItem("token");
    const fetch = httpr(token);

    return new Promise(async (resolve, reject) => {
      fetch
        .get(`${BASE_URL}/api/members/${this.props.memberId}`)
        .then((response) => {
          const memberInfo = response.data;
          let selectedLocIds = [];
          let selectedReports = [];
          let allReportsSelected = false;
          let email,
            confirmEmail,
            firstName,
            lastName,
            admin,
            service = "";

          if (memberInfo) {
            if (this.state.email === "") {
              email = memberInfo.Email;
            }

            if (this.state.confirmEmail === "") {
              confirmEmail = memberInfo.Email;
            }

            if (this.state.firstName === "") {
              firstName = memberInfo.FirstName;
            }

            if (this.state.lastName === "") {
              lastName = memberInfo.LastName;
            }

            if (this.state.admin) {
              admin = memberInfo.Admin === 1 ? true : false;
            }

            if (this.state.service) {
              service = memberInfo.Service === 1 ? true : false;
            }

            if (this.state.selectedLocIds.length <= 0) {
              memberInfo.Locations.map((loc) => {
                selectedLocIds.push(loc.LocationId);
              });
            }

            if (this.state.selectedReports.length <= 0) {
              if (
                memberInfo.ReportIds.split(",").length ===
                this.props.reports.length
              ) {
                selectedReports.push("All");
                allReportsSelected = true;
              } else {
                memberInfo.ReportIds.split(",").map((id) => {
                  selectedReports.push(parseInt(id));
                });
              }
            }

            if (this._isMounted === true) {
              // set states:
              this.setState({
                email: email,
                confirmEmail: confirmEmail,
                firstName: firstName,
                lastName: lastName,
                admin: memberInfo.Admin === 1 ? true : false,
                service: memberInfo.Service === 1 ? true : false,
                selectedLocIds: selectedLocIds,
                selectedReports: selectedReports,
                allReportsSelected: allReportsSelected,
              });
            }
          }
        });
    });
  };

  handleChanged = (event) => {
    if (event.target.name === "selectedReports") {
      if (
        event.target.value[event.target.value.length - 1] === "All" ||
        event.target.value.length === 0
      ) {
        this.setState({
          [event.target.name]: ["All"],
          allReportsSelected: true,
          tc: false,
        });
      } else {
        this.setState({
          [event.target.name]: event.target.value.filter(
            (selected) => selected !== "All"
          ),
          allReportsSelected: false,
          tc: false,
        });
      }
    } else {
      this.setState({ [event.target.name]: event.target.value, tc: false });
    }
  };

  handleSaveUser = () => {
    // reset any existing errors
    this.setState({
      emailErr: false,
      pwErr: false,
      fNameErr: false,
      lNameErr: false,
      locErr: false,
      serviceLocErr: false,
    });

    const validation = memberValidation(this.state, true);

    if (validation.error) {
      if (validation.errorType.length === 1) {
        this.showNotification(validation.msg, validation.errorType);
        this.setState({
          [validation.errorType[0]]: true,
        });
      } else {
        this.showNotification(validation.msg, validation.errorType);
        validation.errorType.map((error) => {
          this.setState({
            [error]: true,
          });
        });
      }
    } else {
      // valdiation succeeded, edit member
      let userInfo = {
        Email: this.state.email,
        Password: this.state.password,
        FirstName: this.state.firstName,
        LastName: this.state.lastName,
        Admin: this.state.admin,
        Service: this.state.service,
        MemberId: this.props.memberId,
        Locations: this.props.locations.filter((location) =>
          this.state.selectedLocIds.includes(location.LocationId)
        ),
        Reports: [],
      };

      if (this.state.allReportsSelected) {
        this.state.reports.map((report) => {
          userInfo.Reports.push(report);
        });
      } else {
        this.state.reports
          .filter((report) =>
            this.state.selectedReports.includes(report.ReportId)
          )
          .map((report) => {
            userInfo.Reports.push(report);
          });
      }

      this.props.saveMember(userInfo);
    }
  };

  handleToggleAdmin = (name) => (event) => {
    const { admin } = this.state;

    this.setState({
      admin: !admin,
    });
  };

  handleToggleService = (name) => (event) => {
    const { service } = this.state;

    this.setState({
      service: !service,
    });
  };

  renderSelectedLocationValues = (event) => {
    const { selectedLocIds } = this.state;
    let locNames = [];

    this.props.locations.map((loc) => {
      if (selectedLocIds.indexOf(loc.LocationId) > -1) {
        locNames.push(loc.LocationName.replace(/_/g, " "));
      }
    });

    return locNames.join(", ");
  };

  renderSelectedReportValues = (event) => {
    if (this.state.allReportsSelected) {
      return "All";
    }
    const { selectedReports } = this.state;
    let reportNames = [];

    event.map((report) => {
      if (selectedReports.indexOf(report.ReportId) > -1) {
        reportNames.push(report.ReportName.replace(/_/g, " "));
      }
    });

    return reportNames.join(", ");
  };

  showNotification = (msg) => {
    this.setState({
      snackbarOpen: true,
      snackbarMsg: msg,
    });
  };

  render() {
    const { classes, memberId } = this.props;
    let allLocations = <div />;

    allLocations = this.props.locations.map((loc) => {
      // Check if location license is expired
      // Note: null/missing license data is treated as valid (isValid: 1)
      const isExpired = loc.license && loc.license.isValid === 0;
      const isExpiringSoon = loc.license && 
                            loc.license.isValid === 1 && 
                            loc.license.daysUntilExpiration !== null &&
                            loc.license.daysUntilExpiration <= 30 &&
                            loc.license.daysUntilExpiration > 0;
      
      // Create location name with license status indicator
      let locationName = loc.OrganizationId === 0
        ? `${loc.LocationName.replace(/_/g, " ")} (Service)`
        : `${loc.LocationName.replace(/_/g, " ")}`;
      
      if (isExpired) {
        locationName = `🔒 ${locationName} (Expired)`;
      } else if (isExpiringSoon) {
        locationName = `⚠️ ${locationName} (${loc.license.daysUntilExpiration} days)`;
      }
      
      return (
        <MenuItem 
          key={loc.LocationId} 
          value={loc.LocationId}
          disabled={isExpired}
          title={isExpired ? "License expired - Contact Socal Safe for renewal" : 
                 isExpiringSoon ? `License expires in ${loc.license.daysUntilExpiration} days - Contact Socal Safe for renewal` : 
                 null}
        >
          <Checkbox
            checked={this.state.selectedLocIds.indexOf(loc.LocationId) > -1}
          />
          <ListItemText primary={locationName} />
        </MenuItem>
      );
    });

    let allReports;
    let showProvisionalCredit = false;
    this.state.locations.map(location => {
      if (location.ProvisionalCredit == 1) {
        showProvisionalCredit = true;
      } 
    });
    if (showProvisionalCredit === true) {
      allReports = this.state.reports.map((report) => {
        return (
          <MenuItem key={report.ReportId} value={report.ReportId}>
            <Checkbox
              checked={this.state.selectedReports.indexOf(report.ReportId) > -1}
            />
            <ListItemText primary={`${report.ReportName.replace(/_/g, " ")} `} />
          </MenuItem>        
        )
      });
     } else { 
       //Hide provisional credit report     
      allReports = this.state.reports.map((report) => {
        if (report.ReportName != "Provisional_Credit") {
          return (
            <MenuItem key={report.ReportId} value={report.ReportId}>
              <Checkbox
                checked={this.state.selectedReports.indexOf(report.ReportId) > -1}
              />
              <ListItemText primary={`${report.ReportName.replace(/_/g, " ")} `} />
            </MenuItem>
          )
        }
      });
    };

    let {
      email,
      confirmEmail,
      firstName,
      lastName,
      selectedLocIds,
    } = this.state;

    return (
      <div className={classes.addMemberControler}>
        <GridContainer>
          <GridItem xs={12} sm={12} md={12}>
            <Card>
              <CardHeader color="success">
                <h4 className={classes.cardTitleWhite}>Edit User</h4>
              </CardHeader>
              <CardBody>
                <GridContainer>
                  <input type="hidden" value="prayer" />
                  <GridItem xs={12} sm={12} md={6}>
                    <CustomInput
                      labelText={email}
                      id="email"
                      name="email"
                      error={this.state.emailErr}
                      onChange={this.handleChanged}
                      formControlProps={{
                        fullWidth: true,
                      }}
                    />
                  </GridItem>
                  <GridItem xs={12} sm={12} md={6}>
                    <CustomInput
                      labelText={confirmEmail}
                      id="confirmEmail"
                      name="confirmEmail"
                      error={this.state.emailErr}
                      onChange={this.handleChanged}
                      formControlProps={{
                        fullWidth: true,
                      }}
                    />
                  </GridItem>
                </GridContainer>
                <GridContainer>
                  <GridItem xs={12} sm={12} md={6}>
                    <CustomInput
                      labelText="Change user's password"
                      id="password"
                      name="password"
                      type="password"
                      error={this.state.pwErr}
                      onChange={this.handleChanged}
                      formControlProps={{
                        fullWidth: true,
                      }}
                    />
                  </GridItem>
                  <GridItem xs={12} sm={12} md={6}>
                    <CustomInput
                      labelText="Confirm new password"
                      id="confirmPassword"
                      name="confirmPassword"
                      error={this.state.pwErr}
                      type="password"
                      onChange={this.handleChanged}
                      formControlProps={{
                        fullWidth: true,
                      }}
                    />
                  </GridItem>
                </GridContainer>

                <GridContainer>
                  <GridItem xs={12} sm={12} md={6}>
                    <CustomInput
                      labelText={firstName}
                      id="firstName"
                      name="firstName"
                      error={this.state.fNameErr}
                      onChange={this.handleChanged}
                      formControlProps={{
                        fullWidth: true,
                      }}
                    />
                  </GridItem>
                  <GridItem xs={12} sm={12} md={6}>
                    <CustomInput
                      labelText={lastName}
                      id="lastName"
                      name="lastName"
                      error={this.state.lNameErr}
                      onChange={this.handleChanged}
                      formControlProps={{
                        fullWidth: true,
                      }}
                    />
                  </GridItem>
                </GridContainer>

                <GridContainer>
                  <GridItem xs={12} sm={12} md={6}>
                    <FormControl className={classes.formControl}>
                      <InputLabel htmlFor="select-multiple-checkbox">
                        Select Locations
                      </InputLabel>
                      <Select
                        name="selectedLocIds"
                        multiple={true}
                        value={selectedLocIds}
                        input={<Input id="select-multiple-checkbox" />}
                        renderValue={() => {
                          return this.renderSelectedLocationValues();
                        }}
                        onChange={this.handleChanged}
                        MenuProps={MenuProps}
                        error={this.state.locErr}
                      >
                        {allLocations}
                      </Select>
                    </FormControl>
                  </GridItem>
                  <GridItem xs={12} sm={12} md={6}>
                    <FormControl className={classes.formControl}>
                      <InputLabel htmlFor="select-multiple-reports">
                        Select Reports
                      </InputLabel>
                      <Select
                        name="selectedReports"
                        multiple={true}
                        value={this.state.selectedReports}
                        input={<Input id="select-multiple-reports" />}
                        renderValue={() => {
                          return this.renderSelectedReportValues(
                            this.state.reports
                          );
                        }}
                        onChange={this.handleChanged}
                        MenuProps={MenuProps}
                        error={this.state.locErr}
                      >
                        <MenuItem value={"All"}>
                          <Checkbox checked={this.state.allReportsSelected} />
                          <ListItemText primary={"All"} />
                        </MenuItem>
                        {allReports}
                      </Select>
                    </FormControl>
                  </GridItem>
                </GridContainer>
                <GridContainer>
                  <GridItem xs={12} sm={12} md={6}>
                    <FormControlLabel
                      control={
                        <Checkbox
                          checked={this.state.admin}
                          onChange={this.handleToggleAdmin("admin")}
                        />
                      }
                      label="Admin Access"
                    />
                    {this.props.isService && (
                      <FormControlLabel
                        control={
                          <Checkbox
                            checked={this.state.service}
                            onChange={this.handleToggleService("service")}
                          />
                        }
                        label="Service Member"
                      />
                    )}
                  </GridItem>
                </GridContainer>
              </CardBody>
              <CardFooter>
                <Button
                  color="success"
                  onClick={() => {
                    this.handleSaveUser();
                  }}
                >
                  Save
                </Button>
                <Button
                  color="transparent"
                  onClick={this.props.handleEditClose}
                >
                  Cancel
                </Button>

                <Snackbar
                  place="tc"
                  color="danger"
                  icon={ErrorOutlineIcon}
                  message={this.state.snackbarMsg}
                  open={this.state.snackbarOpen}
                  closeNotification={() =>
                    this.setState({ snackbarOpen: false })
                  }
                  close
                />
              </CardFooter>
            </Card>
          </GridItem>
        </GridContainer>
      </div>
    );
  }
}

export default withStyles(styles)(EditMember);



// WEBPACK FOOTER //
// ./src/components/Members/EditMember.jsx